// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__OpomG","content":"styles_content__1hwOJ","selectAll":"styles_selectAll__3lK-H"};